import { BID_WORK_TYPE_IDS } from '@shared/data/bid-work-type.util';

const GENERAL_DATA = 'generaldata';
const ANOMALIES = 'anomalies';

function asFiniteNumber(value: unknown): number | null {
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : null;
}

function normalizeBlockType(blockType: unknown): string {
  if (typeof blockType === 'number' && Number.isFinite(blockType)) {
    if (blockType === 2) {
      return GENERAL_DATA;
    }
    if (blockType === 6) {
      return ANOMALIES;
    }
    return String(blockType);
  }

  if (typeof blockType === 'string') {
    const trimmed = blockType.trim().toLowerCase();
    if (trimmed === '2') {
      return GENERAL_DATA;
    }
    if (trimmed === '6') {
      return ANOMALIES;
    }
    return trimmed;
  }

  return '';
}

export function isAnomalySurveyWorkType(bidWorkType: unknown): boolean {
  const n = asFiniteNumber(bidWorkType);
  return n === BID_WORK_TYPE_IDS.AnomalySurvey;
}

export function isAnomaliesBlockType(blockType: unknown): boolean {
  return normalizeBlockType(blockType) === ANOMALIES;
}

export function isAnomalySurveyReport(
  bidWorkType: unknown,
  blockTypes: readonly unknown[]
): boolean {
  if (isAnomalySurveyWorkType(bidWorkType)) {
    return true;
  }

  const n = asFiniteNumber(bidWorkType);
  if (n != null && n > 0) {
    return false;
  }

  return blockTypes.some(isAnomaliesBlockType);
}

export function shouldShowAnomalySurveyReportBlock(blockType: unknown): boolean {
  const key = normalizeBlockType(blockType);
  return key === GENERAL_DATA || key === ANOMALIES;
}
